// Per-garment DEFAULT display tweaks (scale of the 160×240 layer box + offset from the
// body centre). Every garment texture is authored at full-body size, so without a default
// a freshly bought skirt or crown renders as big as the whole character. A player's own
// tweak (state.cloth_tweaks, edited with the 👗 HUD) is stored as ABSOLUTE values and
// simply replaces these; "Resetuj" removes the player's tweak, i.e. returns here.
//
// Values were taken from real players' hand-tuned tweaks (Natalka body) and checked on
// screen. offsetX values were scaled by 0.78 on 2026-09-13 when the Natalka body and all
// garment images were narrowed by that factor (scripts/squeeze_natalka.py). Keys are clothing ids WITHOUT the "cloth_" texture prefix.

export const DEFAULT_TWEAK = { scaleW: 1, scaleH: 1, offsetX: 0, offsetY: 0 };

export const CLOTH_DEFAULTS = {
  bluzka_red:         { scaleW: 0.63, scaleH: 0.43, offsetX: -2, offsetY: -7 },
  bluzka_blue:        { scaleW: 0.48, scaleH: 0.34, offsetX: 1,  offsetY: -9 },
  bluzka_green:       { scaleW: 0.48, scaleH: 0.34, offsetX: 0,  offsetY: -9 },
  bluzka_stripes:     { scaleW: 0.42, scaleH: 0.30, offsetX: 0,  offsetY: -9 },
  spodniczka_pink:    { scaleW: 0.59, scaleH: 0.47, offsetX: 1,  offsetY: 51 },
  spodniczka_jeans:   { scaleW: 0.57, scaleH: 0.47, offsetX: 2,  offsetY: 57 },
  spodniczka_black:   { scaleW: 0.68, scaleH: 0.58, offsetX: 0,  offsetY: 47 },
  spodniczka_flowers: { scaleW: 0.40, scaleH: 0.32, offsetX: 0,  offsetY: 41 },
  buty_sport:         { scaleW: 0.44, scaleH: 0.30, offsetX: -5, offsetY: 98 },
  buty_balet:         { scaleW: 0.41, scaleH: 0.31, offsetX: -2, offsetY: 100 },
  buty_kozaki:        { scaleW: 0.54, scaleH: 0.30, offsetX: 9, offsetY: 100 },
  buty_sandaly:       { scaleW: 0.45, scaleH: 0.30, offsetX: -5, offsetY: 89 },
  akc_kokarda:        { scaleW: 1.0,  scaleH: 1.0,  offsetX: 0,  offsetY: 0 },
  akc_kapelusz:       { scaleW: 0.58, scaleH: 0.33, offsetX: 0,  offsetY: -100 },
  akc_okulary:        { scaleW: 0.34, scaleH: 0.18, offsetX: 0,  offsetY: -62 },
  akc_korona:         { scaleW: 0.55, scaleH: 0.35, offsetX: 1,  offsetY: -100 },
};

// Per-character overrides on top of CLOTH_DEFAULTS (the bodies differ in width, so a
// garment tuned for Natalka may sit wrong on Ken). Only list what actually differs.
export const CHARACTER_OVERRIDES = {
  // Ken's head sits a little lower in the box — headwear tuned for Natalka floats on him.
  ken: {
    akc_korona:   { offsetY: -92 },
    akc_kapelusz: { offsetY: -90 },
    akc_okulary:  { offsetY: -60 },
  },
};

// Slider / server limits — keep in sync with backend/app/game/clothing.py.
export const TWEAK_LIMITS = { scaleMin: 0.1, scaleMax: 2.0, offsetMin: -150, offsetMax: 150 };

const stripPrefix = (clothKey) => clothKey.replace(/^cloth_/, '');

// Base tweak for a garment on a given character (before any player tweak). Accepts the
// clothing id or the "cloth_<id>" texture key.
export function defaultTweak(clothKeyOrId, character = 'natalka') {
  const item = stripPrefix(clothKeyOrId);
  return {
    ...DEFAULT_TWEAK,
    ...(CLOTH_DEFAULTS[item] || {}),
    ...(CHARACTER_OVERRIDES[character]?.[item] || {}),
  };
}
